module.exports = __webpack_public_path__ + "static/dashboard-pro-991cf87d01231650b7ce9d8fe0da9c75.png";